import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Solution from "./Solution";
import Benefits from "./Benefits";

export default function Staffing() {

  //overview*************************
  const services = [
    {
      title: "Short-Term & Long-Term Staffing",
      imageUrl: "images/staffs.png", // Replace with the appropriate icon URL
    },
    {
      title: "Contract-to-Hire",
      imageUrl: "images/contract.png", // Replace with the appropriate icon URL
    },
    {
      title: "Dedicated Teams",
      imageUrl: "images/team.png", // Replace with the appropriate icon URL
    },
    {
      title: "Skill-Specific Augmentation",
      imageUrl: "images/skill.png", // Replace with the appropriate icon URL
    },
  ];

  //key benefits**************************
  const benefits = [
    {
      title: "Access to Top Talent",
      description: ' Connects you with highly skilled and experienced professionals.',
      iconClass: "fas fa-users fa-2x text-info",
    },
    {
      title: "Scalability & Flexibility",
      description: 'Adjusts resources to match evolving project demands.',
      iconClass: "fas fa-chart-line fa-2x text-info",
    },
    {
      title: "Cost Optimization",
      description: 'Minimizes overhead expenses with efficient staffing solutions.',
      iconClass: "fas fa-hand-holding-usd fa-2x text-info",
    },
    {
      title: "Fast Deployment",
      description: 'Quickly integrates talent to meet immediate project needs.',
      iconClass: "fas fa-clock fa-2x text-info",
    },
    {
      title: "Reduced Hiring Risks",
      description: 'Ensures reliable and qualified candidates for every role.',
      iconClass: "fas fa-shield-alt fa-2x text-info",
    },
  ];
  //roles**************************
  const roles = [
    {
      title: "Software Developers & Engineers",
      imgSrc: "images/test.svg",
    },
    {
      title: "Data Analysts & Data Scientists",
      imgSrc: "images/dbackup.svg",
    },
    {
      title: "Cybersecurity Experts",
      imgSrc: "images/dcyber.svg",
    },
    {
      title: "Cloud & Infrastructure Specialists",
      imgSrc: "images/clod.svg",
    },
    {
      title: "Project Managers & Business Analysts",
      imgSrc: "images/ase.svg",
    },
    {
      title: "QA & Testing Professionals",
      imgSrc: "images/dit.svg",
    },
  ];

  return (
    <>
      <div className="aboutus_bg">
        <div className="aboutus-img-content">
          <h1>Services</h1>
        </div>
      </div>

      {/* overview*******************************************************/}

      <Container className="it-overview text-center mt-5 mb-5">
        {/* <h6>OVERVIEW</h6> */}
        <h3 className="text-center" style={{ color: '#0e2b5c' }}>IT Staffing and Resource Augmentation</h3>
        <p style={{ padding: '0 12%', color: '#9b9aad', fontWeight: '500' }}>Our IT Staffing and Resourcing Augmentation specialists will identify and provide skilled technology professionals to meet project demands, support operational continuity, and address skill gaps. We collaborate closely with clients to understand their needs, ensuring flexible, scalable workforce solutions that align with project timelines, budgets, and organizational objectives.</p>
        <Container className="py-3 services-main">
          <Row className="g-4">
            {services.map((service, index) => (
              <Col sm={12} md={12} lg={3} key={index}>
                <Card className="text-center shadow-sm h-100 services-its">
                  <Card.Body>
                    <div className="card-img">
                      <img
                        src={service.imageUrl}
                        alt={service.title}
                        className="service-icon"
                        style={{ width: "100px", marginBottom: "30px", marginTop: '35px' }}
                      />
                    </div>
                    <Card.Title>{service.title}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </Container>

      {/**key benefits ******************************************************/}

      <section className="py-5 text-light" style={{ backgroundColor: "#141b29" }}>
        <Container>
          {/* <h6 className="text-uppercase text-center text-info mb-2">Key Benefits in managing your hiring needs</h6> */}
          <h2 className="text-center mb-5">Key Benefits in managing your hiring needs</h2>
          <Row className="g-4 row-cols-1 row-cols-lg-5">
            {benefits.map((benefit, index) => (
              <Col key={index} className="text-center mb-5">
                <Row>
                  <Col md={4}>
                    <i className={`${benefit.iconClass} fa-2x text-info mb-3`}></i>
                  </Col>
                  <Col md={8}>
                    <h5 style={{ textAlign: 'left' }}>{benefit.title}</h5>
                    <h6 style={{ color: '#9b9aad', textAlign: 'left' }}>{benefit.description}</h6>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/**Our process *******************************************************/}

      <section className="py-5" style={{ backgroundColor: "#f8f8f8" }}>
        <Container>
          {/* Section Title */}
          <div className="text-center mb-4">
            {/* <h6 className="text-uppercase text-info">Benefits</h6> */}
            <h2 className="fw-bold mb-4" style={{ color: '#0e2b5c' }}>
              Our Process
            </h2>
          </div>

          {/* Benefits Row */}
          <Row className="g-4">
            {/* Benefit 1 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Consultation</h5>
                <h6 style={{ lineHeight: '1.625em', color: '#627792' }}>Understands client needs and defines staffing requirements.</h6>
              </div>
            </Col>

            {/* Benefit 2 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Candidate Screening and Selection</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Identifies and evaluates the best-fit candidates.</h6>
              </div>
            </Col>

            {/* Benefit 3 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Integration Support and smooth onboarding</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Ensures seamless integration and smooth employee transition.</h6>
              </div>
            </Col>

            {/* Benefit 4 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Ongoing Support and Management</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Provides continuous support and manages staffing performance.</h6>
              </div>
            </Col>


          </Row>


        </Container>
      </section>
      <Container className="py-3 services-main">

        {/**roles we specialize *********************************************/}
        <section className="py-5">
          <h2 className="fw-bold mb-4" style={{ color: '#0e2b5c', textAlign: 'center' }}>
            Roles We Specialize In
          </h2>
          <Row className="g-4">
            {roles.map((role, index) => (
              <Col key={index} md={4}>
                <Card className="text-center shadow-sm h-100 services-its">
                  <Card.Body>
                    <div className="card-img">
                      <img
                        src={role.imgSrc}
                        alt={role.title}
                        className="service-icon"
                        style={{ width: "100px", marginBottom: "30px", marginTop: '35px' }}
                      />
                    </div>
                    <Card.Title>{role.title}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>
      </Container>
    </>
  )
}